import { isContainerBlock, type TBlock } from '@wp-block-builder/package';

import generateRandomBlockId from './generateRandomBlockId';

function duplicateBlockProps(block: TBlock) {
  if (isContainerBlock(block)) {
    return {
      ...block.props,
      blocks: (block.props?.blocks ?? []).map((b: TBlock | null) => (b === null ? null : duplicateBlock(b))),
    };
  }
  return { ...block.props };
}

export default function duplicateBlock(block: TBlock): TBlock {
  return {
    id: generateRandomBlockId(),
    type: block.type,
    style: { ...block.style },
    sectionProps: { ...block.sectionProps },
    props: duplicateBlockProps(block),
  } as TBlock;
}
